import { useOutletContext } from 'react-router-dom'
import { useSignal } from '@preact/signals-react'

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'

import DbaConfirmationModal from './DbaConfirmationModal.jsx'
import DotnConnectModal from './DotnConnectModal.jsx'
import Icon from '../../../../components/Icon.jsx'

const ShowMerchantForm = function ({merchantSignal}) {

	const { user, config, accessToken, userPermissions, userPermissionsSummary, accordionData } = useOutletContext()

	const currenciesSignal = useSignal([])
	const disallowEditSignal = useSignal(false)
	const selectedCurrencySignal = useSignal('')
	const showModalDbaConfirmationSignal = useSignal(false)
	const showModalDotnConnectSignal = useSignal(false)

	const CurrencySelectElement = function (disabled=null) {
		const currencies = currenciesSignal.value
		let options = []
		for (let i = 0; i < currencies.length; i++) {
			const content = currencies[i]
			options.push(<option key={content.id} value={content.id}>{content.abbNameCombo}</option>)
		}
		return (
			<select onChange={(event) => { selectedCurrencySignal.value = event.target.value }} required={true} {...disabled ? disabled = { disabled } : null} defaultValue={selectedCurrencySignal.value}>
				{options}
			</select >
		)
	}

	function showModalDotnConnect() {
		showModalDotnConnectSignal.value = true
	}

	function showModalDbaConfirmation() {
		showModalDbaConfirmationSignal.value = true
	}

	console.log("Model:")
	console.log(merchantSignal.value)

	return (
		<>
			<Form.Group className="form-group form-group-centered">
				<label htmlFor="name">Name</label>
				<input defaultValue={merchantSignal.value.name} id="merchantName" name="merchantName" className="form-control" maxLength="50" required={true} disabled={disallowEditSignal.value} onChange={(event) => { merchantSignal.value.name = event.target.value }} />
			</Form.Group>
			{
				merchantSignal.value.id && merchantSignal.value.paymentMerchant && (
					merchantSignal.value.paymentMerchant.accessToken ? (
						<>
							<Form.Group className="form-group form-group-centered">
								<label className="col-md-2 col-md-offset-2 control-label">Currency</label>
								<CurrencySelectElement disabled={"disabled"}></CurrencySelectElement>
							</Form.Group>
							<Form.Group className="form-group form-group-centered">
								<label htmlFor="accessToken" className="control-label col-md-2 col-md-offset-2">Access Token</label>
								<input value={merchantSignal.value.paymentMerchant.accessToken} className="form-control" id="accessToken" name="accessToken" disabled="disabled" readOnly />
							</Form.Group>
							<Form.Group>
								{
									merchantSignal.value.dbaName ? (
										<>
											<label htmlFor="connectedTo" className="control-label col-md-2 col-md-offset-2">Connected To</label>
											<div className="col-md-4" style="padding-top:7px;">
												<Button onClick={showModalDbaConfirmation} className="control-label btn-link">{merchantSignal.value.dbaName}</Button>
											</div>
											<div className="col-md-1" style="padding-top:7px;">
												{
													userPermissionsSummary.canEditOrganizations && (
														<Button onClick={showModalDotnConnect} className="pull-right">
															<Icon icon="pencil" height={16} width={16}></Icon>
														</Button>
													)
												}
											</div>
										</>
									) : (
											userPermissionsSummary.canEditOrganizations && (
											<>
												<div className="control-label col-md-2 col-md-offset-2"></div>
												<div className="col-md-4 validation-error" style="padding-top:7px;">
													<Button onClick={showModalDbaConfirmation} className="control-label btn-link">Click here to resolve a merchant error</Button>
												</div>
												<div className="col-md-1" style="padding-top:7px;">
													<Button onClick={showModalDotnConnect} className="pull-right">
														<Icon icon="pencil" height={16} width={16}></Icon>
													</Button>
												</div>
											</>
										)
									)
								}
							</Form.Group>
						</>
					) : (
							userPermissionsSummary.canEditOrganizations && (
							<>
								<Form.Group>
									<label className="col-md-2 col-md-offset-2 control-label">Currency</label>
									<div className="col-md-5">
										<CurrencySelectElement></CurrencySelectElement>
									</div>
								</Form.Group>
								<Form.Group>
									<label className="col-md-2 col-md-offset-2 control-label"></label>
									<Button onClick={showModalDotnConnect} className="col-md-5 btn-link">Connect to DOLLARS ON THE NET</Button>
								</Form.Group>
							</>
						)
					)
				)
			}

			<DbaConfirmationModal showSignal={showModalDbaConfirmationSignal} model={merchantSignal.value}></DbaConfirmationModal>
			<DotnConnectModal showSignal={showModalDotnConnectSignal} model={merchantSignal.value}></DotnConnectModal>
		</>
	)
}
export default ShowMerchantForm